import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import LoadingView from "../../components/ui/LoadingView/LoadingView";

const PageAuth: React.FC = () => {
  const auth = useAuth();

  useEffect(() => {
    auth.signinRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingView />;
};

export default PageAuth;
